import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "@app/services";

import * as endpoints from "./endpoints";
import { dashboard, dashboardFailed, dashboardSuccess } from "./slice";

//--------------------DashboardSagas-------------------------

function* dashboardSaga(action: ReturnType<typeof dashboard>): any {
  try {
    const response = yield call(request.get, endpoints.dashboard);
    yield put(dashboardSuccess(response));
  } catch (error: any) {
    yield put(dashboardFailed(error));
  }
}

function* dashboardSagas() {
  yield all([takeLatest(dashboard, dashboardSaga)]);
}

export { dashboardSagas };
